/** Zones that make up the city region. */
const CITY_ZONES = new Set([
    "village", "threads", "casino", "bank", "citytavern", "food", "ghosts", "furni", "tackle", "smith",
    // the apartment blocks: ground-floor lobby, the two stair-hall floors, and the 4 units — per block
    "aptlobby", "apthall2", "apthall3", "apt2a", "apt2b", "apt3a", "apt3b",
    "anxlobby", "anxhall2", "anxhall3", "anx2a", "anx2b", "anx3a", "anx3b",
]);
/** The region a zone belongs to. plaza/tavern → island; the seven city zones → city; kapon → kapon. */
export function regionOfZone(zone) {
    if (zone === "kapon")
        return "kapon";
    return CITY_ZONES.has(zone) ? "city" : "island";
}
import { KAPON_TERRAIN } from "./constants.js";
/** Server px per world tile (positions are stored in server px; tile centres × 32). */
const TILE_PX = 32;
/**
 * The region a server-px point (x, y) lies in — used server-side for interest filtering, where every
 * entity carries an authoritative position. Kapon is a known box far NORTH (negative z); the spawn
 * island sits near the origin (tile x < 34); everything else (the village + its interiors, spread east)
 * is the city. The three coordinate clusters don't overlap, so this is unambiguous.
 */
export function regionOfPoint(xPx, yPx) {
    const tx = xPx / TILE_PX, ty = yPx / TILE_PX;
    const k = KAPON_TERRAIN;
    if (tx >= k.cx - k.hw && tx <= k.cx + k.hw && ty >= k.cz - k.hd && ty <= k.cz + k.hd)
        return "kapon";
    if (tx < 34)
        return "island";
    return "city";
}
//# sourceMappingURL=regions.js.map